export default __webpack_public_path__ + "static/media/LAMBDA.d84ed9d9.svg";